import Error from '../../../model/Error';
import Helper from '../../../accounting/Helper';
import QueryParamEncoder from '../../../service/QueryParamEncoder';
import TrainerAppointment from '@legacy/js/dto/offering/TrainerAppointment.js';
import axios from 'axios';

export default class TrainerAppointmentRepository {
    static findAllAndGetMeta(clubId, preFilters, offset, limit, sortField, sortDirection) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/trainer-appointments?${QueryParamEncoder.encodeObjectToArray(preFilters, 'filters')}&offset=${offset}&limit=${limit}&orderByField=${sortField}&orderByDirection=${sortDirection}`)
                .then((response) => resolve({ meta: response.data.meta, data: response.data.data.map((data) => TrainerAppointment.fromData(data)) }))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static downloadExcel(clubId, preFilters, sortField, sortDirection) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/trainer-appointments?${QueryParamEncoder.encodeObjectToArray(preFilters, 'filters')}&format=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet&orderByField=${sortField}&orderByDirection=${sortDirection}`, {
                    responseType: 'blob',
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', new Helper().getFilenameFromHeaders(response.headers));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
